import { FETCH_AUDITS } from '../actions/types'

export default (state = [], action) => {
  switch (action.type) {
    case FETCH_AUDITS:
      return action.payload
    default:
      return state
  }
}
